export default __webpack_public_path__ + "static/media/8.7097a968.png";